import { CarouselItem } from '@synoptic/ui-kit/carousel/carousel.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import clsx from 'clsx';
import { Stream, User } from '@/__generated__/schema-types.ts';
import { S3Avatar } from '@/components/s3/user/s3-avatar';
import { ToggleFollowButton } from '@/components/toggle-follow/toggle-follow-button';
import { NavLink } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useIsMe } from '@/routes/_app.$username/use-is-me.ts';
import { HomeCarousel } from '../home-carousel.tsx';
import { carouselItemThirdWidth } from '../home-sections.css.ts';
import { HomeAuthorStreamCard } from './home-author-stream-card.tsx';
import {
  authorDetailsContainer,
  authorStreamDescription,
  authorStreamsContainer,
  winnerUserContainer,
} from './home-authors-section.css.ts';
import {
  userHandle,
  userName,
  userNameUnderline,
} from '@/components/user-badge/user-badge.css';
import { userInfo } from '@/components/user-badge/user-badge.css';
import { userAvatar } from '@/components/user-badge/user-badge.css';

export const HomeAuthorCard = ({ author }: { author: User }) => {
  const AuthorDescription = author.bio ? (
    <p className={authorStreamDescription}>{author.bio}</p>
  ) : null;

  const isMobile = !useIsTablet();

  const isMe = useIsMe(author.username);

  const streams = author?.streams?.items as Stream[];

  return (
    <div>
      <div className={authorDetailsContainer}>
        <div className={winnerUserContainer}>
          <S3Avatar
            className={userAvatar}
            size={'medium'}
            s3Key={author.avatar?.key}
            userId={author.id}
          />
          <div className={userInfo}>
            <NavLink
              className={clsx(userName, userNameUnderline)}
              to={paths.makeUser(author.username)}
            >
              {author.fullName}
            </NavLink>
            <span className={clsx(userHandle)}>{`@${author.username}`}</span>
            {!isMobile && AuthorDescription}
          </div>
        </div>
        {!isMe && (
          <ToggleFollowButton userId={author.id} following={author.following} />
        )}
      </div>
      {isMobile && AuthorDescription}
      {!!streams?.length && (
        <div className={authorStreamsContainer}>
          <HomeCarousel>
            {streams.map((stream) => (
              <CarouselItem
                key={stream.id + '-author-stream'}
                className={carouselItemThirdWidth}
              >
                <HomeAuthorStreamCard stream={stream} />
              </CarouselItem>
            ))}
          </HomeCarousel>
        </div>
      )}
    </div>
  );
};
